import {Component, OnDestroy, OnInit} from '@angular/core';
import {FirebaseService} from '../Services/Firebase/firebase.service';
import {SessionService} from '../Services/Session/session-service.service';
import {interval, Observable, Subscription} from 'rxjs';
import {RealmService} from '../Services/Realm/realm.service';
@Component({
  selector: 'app-emergency',
  templateUrl: './emergency.component.html',
  styleUrls: ['./emergency.component.css', '../../assets/layout/style/layout.css']
})
export class EmergencyComponent implements OnInit, OnDestroy {
  phone = '';
  timer = '';
  emergencyPhones: any[] = [];
  country:any = 502;
  private subscription: Subscription;
  constructor(public fb: FirebaseService, private session: SessionService, private realm: RealmService) { }

  ngOnInit(): void {
    this.session.getData('user').then( (data: any) => {
      this.phone = data.emergencyPhoneNumber;
      this.country = data.phoneArea;
      console.log("emergency: ", this.phone);
      this.startTimer();
      this.realm.getEmergencyPhones(this.country);
    });
    
    
    this.realm.emergencyPhones$.subscribe( (data: any) => {
      console.log("data emergency phones: ", data);
      this.emergencyPhones = JSON.parse(JSON.stringify(data.emergencyPhones));
    });
  }

  startTimer() {
    //let timer = JSON.parse(this.fb.getStringRC('call_time'));
    let timer = JSON.parse("15");
    let seconds;
    this.subscription = interval(1000).subscribe( x => {
      seconds = Math.floor(timer % 60);
      // seconds = seconds < 10 ? '0' + seconds : seconds;
      this.timer = seconds;
      if (--timer == 0) {
        console.log("entra a validacion");
        this.subscription.unsubscribe();
        this.call();
      } else {
        //--timer;
      }
    });
  }
  call() {
    window.open('tel:502'+this.phone);
  }
  cancelTimer() {
    this.subscription.unsubscribe();
  }
  ngOnDestroy(): void {
    this.subscription.unsubscribe();
  }
}
